import { useState } from "react";
import { Button, Checkbox, Tooltip, Modal } from "antd";
import ArrowTopLeft from "../../../assets/icons/arrow_top_left.svg?react";
import { useDontAskAgain } from "../../../utils/useDontAskAgain";

export default function ReturnToDefaultButton({
  reset,
  isDefault,
}: {
  reset: () => void;
  isDefault: boolean;
}) {
  const { dontAskAgain, setDontAskAgain } = useDontAskAgain(
    "returnToDefaultModalDontAskAgain",
  );

  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <ReturnToDefaultModal
        setDontAskAgainLocalStorage={setDontAskAgain}
        isOpen={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        onConfirm={() => {
          reset();
          setIsModalOpen(false);
        }}
      />
      <Tooltip title="Revert all changes to saved workspace state">
        <button
          onClick={() => {
            if (dontAskAgain) {
              reset();
            } else {
              setIsModalOpen(true);
            }
          }}
          disabled={isDefault}
          className="bg-white h-fit py-[6px]  text-[#064C68] px-2  rounded-md border border-[#E0E0E0] flex items-center gap-[2px] font-bold disabled:bg-[#E1E3E3] disabled:border-[#C6C8C8] disabled:text-[#A9AAAA] disabled:cursor-default"
        >
          <ArrowTopLeft />
          Revert
        </button>
      </Tooltip>
    </>
  );
}

const ReturnToDefaultModal = ({
  isOpen,
  onCancel,
  onConfirm,
  setDontAskAgainLocalStorage,
}: {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  setDontAskAgainLocalStorage: (value: boolean) => void;
}) => {
  const [dontAskAgain, setDontAskAgain] = useState(false);
  return (
    <Modal
      open={isOpen}
      footer={
        <div className="flex items-center justify-between">
          <Button
            onClick={onCancel}
            className="bg-white text-[#064C68] border-[#064C68] border hover:border-[#064C68]"
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              onConfirm();
              onCancel();
              setDontAskAgainLocalStorage(dontAskAgain);
            }}
            className="bg-[#0C98D0] text-white  hover:bg-[#064C68]! hover:text-white! border-[#0C98D0] border hover:border-[#064C68]!"
          >
            Confirm
          </Button>
        </div>
      }
      closable={true}
      onCancel={() => onCancel()}
      centered
      title="All Changes Will Be Lost"
    >
      <p className="text-[#2B4752] text-base mb-4">
        Revert changes and restore this workspace to its last saved state. Any
        unsaved changes will be lost.
      </p>
      <Checkbox
        onChange={(e) => {
          setDontAskAgain(e.target.checked);
        }}
        checked={dontAskAgain}
      >
        Don&apos;t ask me again
      </Checkbox>
    </Modal>
  );
};
